import sanitizeHtmlLib from 'sanitize-html';

/**
 * Sanitizes HTML content to prevent XSS attacks.
 * Only allows safe formatting tags and removes all event handlers and scripts.
 *
 * @param html - The HTML string to sanitize
 * @returns Sanitized HTML string safe for rendering
 */
export const sanitizeHtml = (html: string): string => {
  return sanitizeHtmlLib(html, {
    allowedTags: ['b', 'i', 'em', 'strong', 'br', 'p', 'ul', 'ol', 'li', 'span'],
    allowedAttributes: {},
  });
};